import type { DashboardMessageKey } from './messages';

export const pageTitleKeys: Record<string, DashboardMessageKey> = {
  '/': 'nav.dashboard',
  '/campaigns': 'nav.campaigns',
  '/campaigns/agencies': 'nav.campaigns.agency',
  '/campaigns/brands': 'nav.campaigns.brands',
  '/campaigns/supply/apps': 'nav.campaigns.supply',
  '/campaigns/channel-groups': 'nav.campaigns.channelGroups',
  '/campaigns/campaigns': 'nav.campaigns.campaigns',
  '/campaigns/creatives': 'nav.campaigns.creatives',
  '/targeting': 'nav.targeting',
  '/debug': 'nav.debug',
  '/admin/users': 'nav.admin.users',
  '/admin/changelog': 'nav.admin.changelog',
  '/a2v': 'nav.a2v',
  '/a2v/assets': 'nav.a2v.assets',
  '/a2v/network-template': 'nav.a2v.networkTemplate',
  '/networks': 'networks.title',
  '/supply': 'nav.supply',
  '/supply/publishers': 'nav.supply.publishers',
  '/supply/placements': 'nav.supply.placements',
  '/supply/lists': 'nav.supply.lists',
  '/supply/lists/all': 'nav.supply.lists',
  '/supply/lists/rewrite': 'nav.supply.lists',
  '/supply/lists/schain': 'nav.supply.lists',
  '/supply/blocked-list': 'nav.supply.blockedList',
  '/supply/blocked-list/creatives': 'nav.supply.blockedList',
  '/supply/apps': 'supplyApps.tabs.apps',
  '/supply/apps/requests': 'supplyApps.tabs.requests',
  '/supply/domains': 'nav.supply.domains',
  '/supply/tailored-supply': 'nav.supply.tailoredSupply',
  '/supply/endpoint-generator': 'nav.supply.endpointGenerator',
  '/supply/ads-txt': 'nav.supply.adsTxt',
  '/supply/ads-txt/records': 'nav.supply.adsTxt',
  '/supply/ads-txt/apps': 'nav.supply.adsTxt',
  '/supply/ads-txt/domains': 'nav.supply.adsTxt',
  '/demand': 'nav.demand.partners',
  '/demand/owners': 'nav.demand.owners',
  '/demand/partners': 'nav.demand.partners',
  '/demand/integrations': 'nav.demand.integrations',
  '/demand/deals': 'nav.demand.deals',
  '/reporting': 'nav.reporting.reportExplorer',
  '/reporting/report-explorer': 'nav.reporting.reportExplorer',
  '/reporting/performance-analyzer': 'nav.reporting.performanceAnalyzer',
  '/reporting/network-performance': 'nav.reporting.networkPerformance',
  '/reporting/saved-reports': 'nav.reporting.savedReports',
  '/reporting/saved-reports/shared': 'savedReports.tabs.shared',
};

export const pageTitlePrefixKeys: Array<readonly [string, DashboardMessageKey]> = [
  ['/campaigns/creatives/', 'nav.campaigns.creatives'],
  ['/p/', 'dashboard.publisher.title'],
  ['/campaigns/supply/', 'nav.campaigns.supply'],
  ['/campaigns/brands/', 'nav.campaigns.brands'],
  ['/campaigns/agencies/', 'nav.campaigns.agency'],
  ['/campaigns/campaigns/', 'nav.campaigns.campaigns'],
  ['/targeting/', 'nav.targeting'],
  ['/admin/changelog', 'nav.admin.changelog'],
  ['/admin/', 'nav.admin.users'],
  ['/a2v/network-template', 'nav.a2v.networkTemplate'],
  ['/a2v/', 'nav.a2v.assets'],
  ['/networks/edit/', 'networks.editTitle'],
  ['/networks/', 'networkDashboard.title'],
  ['/supply/publishers', 'nav.supply.publishers'],
  ['/supply/placements', 'nav.supply.placements'],
  ['/supply/lists/', 'nav.supply.lists'],
  ['/supply/blocked-list/', 'nav.supply.blockedList'],
  ['/supply/apps', 'nav.supply.apps'],
  ['/supply/domains', 'nav.supply.domains'],
  ['/supply/tailored-supply', 'nav.supply.tailoredSupply'],
  ['/supply/endpoint-generator', 'nav.supply.endpointGenerator'],
  ['/supply/ads-txt', 'nav.supply.adsTxt'],
  ['/supply/', 'nav.supply'],
  ['/demand/owners', 'nav.demand.owners'],
  ['/demand/integrations', 'nav.demand.integrations'],
  ['/demand/partners', 'nav.demand.partners'],
  ['/demand/deals', 'nav.demand.deals'],
  ['/reporting/network-performance', 'nav.reporting.networkPerformance'],
  ['/reporting/', 'nav.reporting.reportExplorer'],
];
